import React, { Component } from 'react'
import _ from 'underscore'
import { Row, Col, Input, Radio, Spin, message } from 'antd'
import { app, api } from "../../app"
import Card from '../../components/Card'
import TETeamDynamic from "./TETeamDynamic"
import TETeamName from "./TETeamName"
import TETeamPublic from "./TETeamPublic"
import TETeamMien from "./TETeamMien"
import TETeamGrant from "./TETeamGrant"
import TETeamEquipment from "./TETeamEquipment"

const RadioGroup = Radio.Group
const RadioButton = Radio.Button

class TeamEdit extends Component {
    constructor(props) {
        super(props)
        this.state = {
            rights: app.getData("rights"),
            sel_tab: null,
            team_sel_index: '0',
            select_team: {},
            teamList: [],
            all_team: [],
            isSelect: 0,
        }
    }

    async componentDidMount() {
        this._isMounted = true
        await this.handleTeamData()
        await this.setData({ sel_tab: '6' })
    }

    componentWillUnmount() {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 队伍列表数据
     **/
    handleTeamData = async () => {
        await this.setData({ team_loading: true })
        let params = {
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.TeamAll, params)
        let state = { team_loading: false }
        if (flag === 1) {
            state.teamList = data
            state.all_team = data
            state.select_team = data[parseInt(this.state.team_sel_index)]
        } else {
            app.alert(msg, "error")
        }
        this.setData(state)
        if (localStorage.getItem('targetValue')) {
            this.recordTarget(localStorage.getItem('targetValue'));
        }
    }

    /**
     * 搜索
     * @param value
     */
    handleSearchTeam = (value) => {
        let { all_team } = this.state
        let teamList = []
        if (value) {
            teamList = _.filter(all_team, ({ teamname }) => teamname.indexOf(value) !== -1)
        } else {
            teamList = all_team
        }
        let state = { teamList }
        if (teamList.length > 0) {
            state.team_sel_index = '0'
            state.select_team = teamList[0]
        }
        this.setData(state)
    }

    recordTarget = (value) => {
        // console.log("进来了" + value)
        let index = parseInt(value);
        let { teamList, team_sel_index } = this.state
        // console.log(teamList)
        if (value === team_sel_index) return false;
        this.setData({ team_sel_index: value, select_team: teamList[index] })
    }

    /**
     * 队伍选择变更
     * @param e
     */
    handleTeamChange = async (e) => {
        let { value } = e.target
        let { teamList, team_sel_index } = this.state
        if (value === team_sel_index) return
        let index = parseInt(value)
        localStorage.setItem('targetValue', value);
        localStorage.setItem('targetId', teamList[index].team_id);
        this.setData({ team_sel_index: value, select_team: teamList[index] })
    }

    /**
     * 选项选择变更
     * @param e
     */
    handleTabChange = (e) => {
        let { value } = e.target
        let { sel_tab } = this.state
        if (value === sel_tab) return
        this.setData({ sel_tab: value })
    }

    /**
     * 选择队伍
     * @param select_team
     */
    handleSelectTeam = (select_team) => {
        this.setData({ select_team })
    }

    render() {
        let { sel_tab, team_sel_index, teamList, select_team, testNum, team_loading } = this.state,
            loadNode = (<Row className="data-loading" type="flex" align="middle" justify="center"><Spin /></Row>),
            content = loadNode,
            tab_disabled = !sel_tab
        switch (sel_tab) {
            case "1":
                content = (<TETeamGrant team={select_team} />)
                break
            case "2":
                content = (<TETeamEquipment team={select_team} />)
                break
            case "3":
                content = (<TETeamDynamic team={select_team} />)
                break
            case "4":
                content = (<TETeamPublic team={select_team} />)
                break
            case "5":
                content = (<TETeamMien team={select_team} />)
                break
            case "6":
                content = (<TETeamName team={select_team} flushTeam={async () => {
                    await this.setData({ team_sel_index: '0' })
                    await this.handleTeamData()
                }} />)
                break
        }

        return (
            <div className="team-editor">
                <Row className="top-title" type="flex" justify="space-between">
                    <Col>编辑队伍</Col>
                    <RadioGroup value={sel_tab} buttonStyle="solid" onChange={this.handleTabChange}>
                        <RadioButton className='no-select' value="6" disabled={tab_disabled}>队伍设置</RadioButton>
                        {/*<RadioButton className='no-select' value="1" disabled={tab_disabled}>注册信息</RadioButton>*/}
                        {/*<RadioButton className='no-select' value="2" disabled={tab_disabled}>队伍装备</RadioButton>*/}
                        {/*<RadioButton className='no-select' value="3" disabled={tab_disabled}>队伍动态</RadioButton>*/}
                        {/*<RadioButton className='no-select' value="4" disabled={tab_disabled}>队内公开</RadioButton>*/}
                        {/*<RadioButton className='no-select' value="5" disabled={tab_disabled}>队内风采</RadioButton>*/}
                    </RadioGroup>
                </Row>
                <Row className="content">
                    <Col span={6} className="team-select">
                        <Card width="100%" height="100%" style={{ padding: 25, height: 'calc(100% - 68px)' }}
                            title="队伍选择">
                            {
                                team_loading ? loadNode :
                                    <div style={{ height: '100%' }}>
                                        <Input.Search placeholder="输入队伍名搜索" onSearch={this.handleSearchTeam}
                                            className="search" />
                                        <RadioGroup onChange={this.handleTeamChange} className="team-list"
                                            value={team_sel_index} buttonStyle="solid">
                                            {
                                                teamList.length > 0 ?
                                                    teamList.map((team, index) => {
                                                        return (
                                                            <RadioButton key={index} className='no-select'
                                                                value={index + ''}>
                                                                <div title={team.teamname}>{team.teamname}</div>
                                                            </RadioButton>
                                                        )
                                                    }) :
                                                    (<p style={{ textAlign: "center", padding: "20px 0" }}>无对应队伍</p>)
                                            }
                                        </RadioGroup>
                                    </div>
                            }
                        </Card>
                    </Col>
                    <Col span={17} offset={1} className="team-info">
                        <Card width="100%" height="100%"
                            title={<div style={{ height: 32 }}>
                                {select_team.teamname || '正在加载 ...'}
                            </div>}
                            style={{ padding: 25, height: 'calc(100% - 68px)' }}>
                            {content}
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default TeamEdit



// WEBPACK FOOTER //
// ./src/routes/ranks/TeamEdit.jsx